import Vue from "vue";

const globalData = new Vue({
  data: {
    $globalScrollTop: 0,
    $globalDirection: '',
    $globalContactLink: `/contact/exhibitor-sales?brand=microsoft`,
    $globalMainSiteUrl: window.location.origin
  }
});
Vue.mixin({
  computed: {
    $globalScrollTop: {
      get: function () {
        return globalData.$data.$globalScrollTop
      },
      set: function (value) {
        globalData.$data.$globalScrollTop = value;
      }
    },
    $globalDirection: {
      get: function () {
        return globalData.$data.$globalDirection
      },
      set: function (value) {
        globalData.$data.$globalDirection = value;
      }
    },
    $globalIsMobileDevice: {
      get: function () {
        return /Mobi|Android/i.test(navigator.userAgent)
      }
    },
    $globalIsTouchDevice: {
      get: function () {
        return 'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
      },
    },
    $globalIsDevelopment: {
      get: function () {
        return process.env.NODE_ENV === 'development'
        // || window.globalData.APP_ENV === 'local'
        // || window.globalData.APP_ENV === 'staging'
      }
    },
    $globalIsOfficial: {
      get: function () {
        return window.globalData.APP_ENV === 'production'
      }
    },
    $globalContactLink: {
      get: function () {
        return globalData.$data.$globalContactLink
      },
    },
    $globalMainSiteUrl: {
      get: function () {
        return globalData.$data.$globalMainSiteUrl
      },
    },
  }
});
